import { useState, type FormEvent } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api, type MeResponse } from '@/lib/api';

const input =
  'border-input bg-card focus:ring-ring h-12 w-full rounded-lg border px-3 text-base focus:ring-2 focus:outline-none';

/** Changement de son propre mot de passe. */
export default function MyAccount({ session }: { session: MeResponse }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [mismatch, setMismatch] = useState(false);

  const change = useMutation({
    mutationFn: () =>
      api('/api/auth/password', {
        method: 'POST',
        body: JSON.stringify({ currentPassword: current, newPassword: next }),
      }),
    onSuccess: () => {
      setCurrent('');
      setNext('');
      setConfirm('');
    },
  });

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    setMismatch(next !== confirm);
    if (next === confirm) change.mutate();
  }

  return (
    <section className="panel max-w-md space-y-4 p-4">
      <div>
        <h1 className="page-title">Mon compte</h1>
        <p className="text-muted-foreground text-sm">
          {session.user.fullName} · {session.user.username}
        </p>
      </div>
      <form onSubmit={onSubmit} className="space-y-3">
        <label className="block space-y-1">
          <span className="text-sm font-medium">Mot de passe actuel</span>
          <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" required className={input} />
        </label>
        <label className="block space-y-1">
          <span className="text-sm font-medium">Nouveau mot de passe (8 caractères minimum)</span>
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" minLength={8} required className={input} />
        </label>
        <label className="block space-y-1">
          <span className="text-sm font-medium">Confirmer le nouveau mot de passe</span>
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" required className={input} />
        </label>
        {mismatch && <p className="text-destructive text-sm">Les deux mots de passe ne correspondent pas.</p>}
        {change.isError && <p className="text-destructive text-sm">{(change.error as Error).message}</p>}
        {change.isSuccess && <p className="text-sm font-medium text-emerald-700">Mot de passe changé.</p>}
        <button
          type="submit"
          disabled={change.isPending}
          className="bg-primary text-primary-foreground hover:bg-primary-dark btn-caps h-12 w-full rounded-lg transition-colors disabled:opacity-50"
        >
          {change.isPending ? 'Enregistrement…' : 'Changer le mot de passe'}
        </button>
      </form>
    </section>
  );
}
